'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { hoverContentEvents } from 'LayoutBuilderUI/actions/userInterfaceActions';
import { getCollaborationSidebarState } from 'ContentEditorUI/redux/selectors/collaborationSidebarSelectors';
import { COMMENTABLE_AREA } from 'LayoutBuilderUI/lib/DragDropConstants';
import { jsx as _jsx } from "react/jsx-runtime";
class MouseEventsHandler extends Component {
  constructor(...args) {
    super(...args);
    this.targetIsElementDropDown = target => {
      return target && target.attributes && target.attributes['data-toolbar-dropdown'];
    };
    this.shouldMouseEventFire = (target = {}, relatedTarget = {}) => {
      if (this.props.isSelected) return false;
      const relatedTargetIsDropdown = this.targetIsElementDropDown(target);
      const targetIsDropdown = this.targetIsElementDropDown(relatedTarget);
      return !relatedTargetIsDropdown && !targetIsDropdown && !this.props.isCommentModeActive;
    };
    this.onMouseOver = e => {
      const {
        id
      } = this.props;
      if (this.shouldMouseEventFire(e.target, e.relatedTarget)) {
        this.props.mouseOverEvent(id);
      }
    };
    this.onMouseLeave = e => {
      if (this.shouldMouseEventFire(e.target, e.relatedTarget)) {
        this.props.mouseLeaveEvent();
      }
    };
  }
  render() {
    const {
      onClick,
      type
    } = this.props;
    return (
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx("div", {
        onMouseOver: this.onMouseOver,
        onMouseLeave: this.onMouseLeave,
        onClick: onClick
        // commentable areas don't need styling through the mouse-events-handler class
        ,
        className: type !== COMMENTABLE_AREA ? 'mouse-events-handler' : '',
        "data-test-id": `${type}-mouse-events-handler`,
        children: /*#__PURE__*/_jsx("div", {
          className: "mouse-events-handler-children",
          children: this.props.children
        })
      })
    );
  }
}
MouseEventsHandler.propTypes = {
  mouseLeaveEvent: PropTypes.func,
  mouseOverEvent: PropTypes.func,
  onClick: PropTypes.func,
  children: PropTypes.node,
  type: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  isSelected: PropTypes.bool,
  isCommentModeActive: PropTypes.bool
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    mouseOverEvent: id => dispatch(hoverContentEvents[ownProps.type].mouseOverEvent(id)),
    mouseLeaveEvent: () => dispatch(hoverContentEvents[ownProps.type].mouseLeaveEvent())
  };
};
export default connect(state => ({
  isCommentModeActive: getCollaborationSidebarState(state).isCommentModeActive
}), mapDispatchToProps)(MouseEventsHandler);